import store from "@/store"
import { GET_ASSURANCES } from "@/store/action.type"

/**
 * Get assurance
 *
 * @param {number|string} assurance_level_id
 * @param {number|string} year_id
 * @param {number|string} faculty_id
 * @param {number|string} major_id
 */
export const getAssurances = (
  assurance_level_id,
  year_id,
  faculty_id,
  major_id
) => {
  const queryOption = {
    1: `?assurance_level_id=${assurance_level_id}&year_id=${year_id}`,
    2: `?assurance_level_id=${assurance_level_id}&year_id=${year_id}&faculty_id=${faculty_id}`,
    3: `?assurance_level_id=${assurance_level_id}&year_id=${year_id}&major_id=${major_id}`,
  }

  store.dispatch(GET_ASSURANCES, {
    query: queryOption[assurance_level_id],
  })
}
